import React from "react";

import { useTranslation } from "react-i18next";
import { IoMdClose } from "react-icons/io";

import { Wrapper, Icon, Title, Text, Content } from "./styles";


export const ExpiredTokenComponent = () => {
  const { t: translate } = useTranslation();

  return (
    <Wrapper>
      <Icon>
        <IoMdClose />
      </Icon>

      <Content>
        <Title aria-label="expiredComponentTitle">{translate("theLinkHasExpired")}</Title>

        <Text>{translate("theEstimatedQuoteLinkHasExpired")}</Text>
      </Content>
    </Wrapper>
  )
}
